import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_YEARLY_CONTRIBUTIONS = createFcmConfig('membership_yearly_contributions', {
	normalizer: createJsonNormalizer(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
				yearly: { type: 'array', shape: { type: 'number' }, optional: true },
			},
		}),
	),
	defaultValue: undefined,
});
